import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useFilterContext } from "../../contexts/FilterContext";
import CustomSelect from "../form/CustomSelect";
import { GetCorporateCustomers } from "../../api/corporate-customers/getCorporateCustomers";

// "individual" / "corporate" are backend sentinels that cannot combine with
// company ids, so picking one clears everything else and vice versa.
const SENTINEL_VALUES = ["individual", "corporate"];

const CompanyFilter = ({ className, inputStyles }) => {
    const { t } = useTranslation();
    const { name, filterValue, setFilterValue, updateURLParams } = useFilterContext();

    const [companies, setCompanies] = useState([]);

    useEffect(() => {
        const fetchCompanies = async () => {
            try {
                const response = await GetCorporateCustomers({ limit: -1, offset: 0, status: 1 });
                setCompanies(
                    (response.data || []).map((company) => ({
                        value: String(company.id),
                        label: company.corporate_name,
                    }))
                );
            } catch (error) {
                console.error("Failed to fetch client companies:", error);
            }
        };
        fetchCompanies();
    }, []);

    const sentinelOptions = [
        { value: "individual", label: t("All Individual Orders") },
        { value: "corporate", label: t("All Company Orders") },
    ];

    const groupedOptions = [
        { label: t("Order Type"), options: sentinelOptions },
        { label: t("Companies"), options: companies },
    ];

    const allOptions = [...sentinelOptions, ...companies];
    const selectedValues = filterValue ? filterValue.split(",") : [];
    const selectedOptions = allOptions.filter((option) => selectedValues.includes(option.value));

    const handleChange = (selected, actionMeta) => {
        let next = selected || [];

        if (actionMeta?.action === "select-option" && actionMeta.option) {
            next = SENTINEL_VALUES.includes(actionMeta.option.value)
                ? [actionMeta.option]
                : next.filter((option) => !SENTINEL_VALUES.includes(option.value));
        }

        const value = next.map((option) => option.value).join(",");
        setFilterValue(value);
        updateURLParams(name, value);
    };

    return (
        <div className={`filter ${className || ""}`} style={inputStyles}>
            <CustomSelect
                isMulti
                isClearable
                options={groupedOptions}
                value={selectedOptions}
                onChange={handleChange}
                placeholder={<div>{t("All Orders")}</div>}
                styles={{
                    menu: (provided) => ({
                        ...provided,
                        minWidth: "100%",
                        width: "max-content",
                        maxWidth: "340px",
                        overflowWrap: "anywhere",
                    }),
                }}
            />
        </div>
    );
};

export default CompanyFilter;
